import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=4aefebc5&scoped=true&"
import script from "./mall.vue?vue&type=script&lang=js&"
export * from "./mall.vue?vue&type=script&lang=js&"
import style0 from "./mall.vue?vue&type=style&index=0&id=4aefebc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aefebc5",
  null
  
)

export default component.exports